import { GENERIC_EMAIL_DOMAINS } from './constants';

interface EmailInfo {
  isGeneric: boolean;
  extension: string | null;
  domain: string | null;
  topLevelDomain: string | null;
}

export function getEmailInfo(email: string): EmailInfo {
  try {
    const domain = email.split('@')[1].toLowerCase();
    const extension = domain.split('.').slice(-1)[0];
    const topLevelDomain = domain.split('.')[0].toLowerCase();
    const isGeneric = GENERIC_EMAIL_DOMAINS.includes(domain);

    return {
      isGeneric,
      extension,
      domain,
      topLevelDomain,
    };
  } catch {
    return {
      isGeneric: false,
      extension: null,
      domain: null,
      topLevelDomain: null,
    };
  }
}
